import { useQuery } from '@tanstack/react-query';

import { RQ_GROUPS_BY_ID_KEY } from '@/modules/ReactQuery/cacheKeys';
import { fetchGroupsById } from '@/modules/categories/api';

export function useGroupsById(
  { enabled }: { enabled: boolean } = { enabled: true }
) {
  return useQuery({
    queryKey: [RQ_GROUPS_BY_ID_KEY],
    queryFn: () => fetchGroupsById(),
    staleTime: Infinity,
    enabled,
  });
}
